module.exports = __webpack_public_path__ + "img/code-task.4c721088.svg";